import React from 'react';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * Common colors.
 * Generate a name from HEX color: http://chir.ag/projects/name-that-color
 * If the name already exists, try to be creative by adding a suffix :)
 */


var blue = '#4978BC';
var blueTint = '#6D93C9';

var _templateObject, _templateObject2;

var Progress = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 0.75rem;\n  background-color: ", "80;\n\n  @media screen and (min-width: 90rem) {\n    & {\n      height: 0.5rem;\n    }\n  }\n"])), blueTint);
var Bar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: inherit;\n  transition: 0.2s linear;\n  width: ", "%;\n  background-color: ", ";\n  transition: width 0.5s ease-in-out;\n"])), function (props) {
  return props.value * 100;
}, blue);

function ProgressBar(_ref) {
  var percentage = _ref.percentage;
  return (
    /*#__PURE__*/
    React.createElement(Progress, null,
    /*#__PURE__*/
    React.createElement(Bar, {
      value: percentage
    }))
  );
}

export default ProgressBar;